import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-external",
  "use": "icon-external-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-external\"><path d=\"M15.116 8.538 7.776 22.52c-.352.672.132 1.48.884 1.48h14.678c.754 0 1.236-.808.884-1.48l-7.34-13.982a.993.993 0 0 0-1.766 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol